import React from "react";
import PropTypes from "prop-types";
import { InputField } from "../../FormField";
import RadioButtonGroup from "../common/RadioButtonGroup";

const MedicalQuestionnaire = ({ data }) => {
  return (
    <fieldset>
      <table className="health-declaration">
        <thead className="header--black">
          <tr>
            <td rowSpan={2} />
            <td width="60%" rowSpan={2}>
              <h3>MEDICAL QUESTIONNAIRE (all 11 questions must be answered)</h3>
            </td>
            <td colSpan={2}>Employee</td>
            <td colSpan={2}>Spouse</td>
          </tr>
          <tr>
            <td>Yes</td>
            <td>No</td>
            <td>Yes</td>
            <td>No</td>
          </tr>
        </thead>
        <tbody>
          <RadioButtonGroup
            data={data}
            questionDesc="Are you a member of any military force (excluding National Reservist), do you contemplate to engage, or the past 5 years, have you engaged in any private flying or hazardous sports or races or flying other than as a fare paying paying passenger on a regular sheduled airline?"
            questionNumber={1}
            questionId="Adventure"
            options={["Yes", "No"]}
            columns={["Emp", "Sp"]}
          />
          <RadioButtonGroup
            data={data}
            field={data["EmpAlcoholDetails"]}
            questionDesc="Do you drink wine,beer or spirit?If so, please state type, quantity and frequency"
            questionNumber={2}
            questionId="ConsumeAlcohol"
            options={["Yes", "No"]}
            columns={["Emp", "Sp"]}
          />
          <RadioButtonGroup
            data={data}
            questionDesc="Has any application for or reinstatement of life or accident insurance ever been declined, postponed, rated or in any way modified?"
            questionNumber={3}
            questionId="Exclusions"
            options={["Yes", "No"]}
            columns={["Emp", "Sp"]}
          />
          <RadioButtonGroup
            data={data}
            questionDesc="To the best of your knowledge and belief, has any of your immediate family ever had tuberculosis, diabetes, heart disease, mental disease or any AIDS related condition?"
            questionNumber={4}
            questionId="FamilyHistory"
            options={["Yes", "No"]}
            columns={["Emp", "Sp"]}
          />
          <RadioButtonGroup
            data={data}
            questionDesc="Have you EVER used any habit forming drugs or narcotics or alcohol excessively or treated for alcoholism or drug habits?"
            questionNumber={5}
            questionId="DrugAddiction"
            options={["Yes", "No"]}
            columns={["Emp", "Sp"]}
          />
          <tr>
            <td>6</td>
            <td>In the past 12 months,</td>
            <td />
            <td />
            <td />
            <td />
          </tr>
          <RadioButtonGroup
            data={data}
            field={data["EmpSmokeQuantity"]}
            questionDesc="a) have you smoked cigarettes? If so, how many per day?"
            questionId="Smoke"
            options={["Yes", "No"]}
            columns={["Emp", "Sp"]}
          />
          <RadioButtonGroup
            data={data}
            field={data["EmpSmokeLessQuantity"]}
            questionDesc="b) did you previously smoke more than you do not?If so, how many did you smoke when you cut down, stop on whose advice?"
            questionId="SmokeLess"
            options={["Yes", "No"]}
            columns={["Emp", "Sp"]}
          />
          <RadioButtonGroup
            data={data}
            field={data["EmpWeightLossReason"]}
            questionDesc="c) have you lost more than 3 kgs(6.6 lbs) of weight?If so, give the reason for the loss."
            questionId="WeightLoss"
            options={["Yes", "No"]}
            columns={["Emp", "Sp"]}
          />
          <tr>
            <td>7</td>
            <td>Have you EVER had or been told you had or been treated for:</td>
            <td />
            <td />
            <td />
            <td />
          </tr>
          <RadioButtonGroup
            data={data}
            questionDesc="a) asthma, tuberculosis, respiratory or lung disease?"
            questionId="LungDisorder"
            options={["Yes", "No"]}
            columns={["Emp", "Sp"]}
          />
          <RadioButtonGroup
            data={data}
            questionDesc="b) rheumatic fever, high blood pressure, stroke,chest pain, heart murmur, disease of the heart,"
            questionId="HeartDisorder"
            options={["Yes", "No"]}
            columns={["Emp", "Sp"]}
          />
          <RadioButtonGroup
            data={data}
            questionDesc="c) peptic ulcer or bowel, liver or gall bladder disease?"
            questionId="GallbladderDisorder"
            options={["Yes", "No"]}
            columns={["Emp", "Sp"]}
          />
          <RadioButtonGroup
            data={data}
            questionDesc="d) renal stone, abnormal urinalysis or any disorder of the genito-urinary system?"
            questionId="KidneyDisorder"
            options={["Yes", "No"]}
            columns={["Emp", "Sp"]}
          />
          <RadioButtonGroup
            data={data}
            questionDesc="e) epilepsy, mental or nervous disorder?"
            questionId="MentalDisorders"
            options={["Yes", "No"]}
            columns={["Emp", "Sp"]}
          />
          <RadioButtonGroup
            data={data}
            questionDesc="f) diabetes, venereal disease, cancer, tumour or any other disease, disorder or severe injury?"
            questionId="BloodDisorder"
            options={["Yes", "No"]}
            columns={["Emp", "Sp"]}
          />
          <RadioButtonGroup
            data={data}
            questionDesc="g) hepatitis or found to be a carrier of hepatitis B?"
            questionId="HepatitisDisease"
            options={["Yes", "No"]}
            columns={["Emp", "Sp"]}
          />
          <RadioButtonGroup
            data={data}
            questionDesc="h) any form of eye, hearing or speech disorder or disease?"
            questionId="HearingAndSight"
            options={["Yes", "No"]}
            columns={["Emp", "Sp"]}
          />
          <RadioButtonGroup
            data={data}
            questionDesc="i) any disease or disorder of muscles, spine,brain, joints and limbs including loss of sensation, tremor or giddiness?"
            questionId="PhysicalInjury"
            options={["Yes", "No"]}
            columns={["Emp", "Sp"]}
          />
          <RadioButtonGroup
            data={data}
            questionNumber={8}
            questionDesc="Have you received any medical advice, counselling or treatment in connection with AIDS Related Complex
             or any other AIDS related condition, or been told you had any of these or that you had a positive HIV blood test or in
             the last 3 months had any of the following symptoms for more than 1 week continuously : fatigue, weght loss, diarrhoea,
             enlarged lymph nodes or unusual skin lesions?"
            questionId="SexualDisease"
            options={["Yes", "No"]}
            columns={["Emp", "Sp"]}
          />
          <tr>
            <td>9</td>
            <td>In the past 5 years, have you had any :</td>
            <td />
            <td />
            <td />
            <td />
          </tr>
          <RadioButtonGroup
            data={data}
            field={data["EmpPreHealthScreeningDetails"]}
            questionDesc="a) pre-employment/annual check-up, health screening? If so, please state the result, date done and name and address of
             Clinic where tests are done in the space provide below."
            questionId="PreHealthScreening"
            options={["Yes", "No"]}
            columns={["Emp", "Sp"]}
          />
          <RadioButtonGroup
            data={data}
            questionDesc="b) diagnostic tests such as X-ray, electrocardiogram or blood study?"
            questionId="DiagnosisInfo"
            options={["Yes", "No"]}
            columns={["Emp", "Sp"]}
          />
          <RadioButtonGroup
            data={data}
            questionDesc="c) double vision, coughing with blood, nose bleeds, tarry stools or bleeding from the rectum or urinary tract?"
            questionId="ExcretoryDisease"
            options={["Yes", "No"]}
            columns={["Emp", "Sp"]}
          />
          <RadioButtonGroup
            data={data}
            questionDesc="d) illness, operation, medical advice, hospital treatment not mentioned above?"
            questionId="OtherDisorder"
            options={["Yes", "No"]}
            columns={["Emp", "Sp"]}
          />
          <RadioButtonGroup
            data={data}
            questionNumber={10}
            questionDesc="Are you also insured or insured as a dependant under another Group policy with AIA? If yes, please furnish information of the other policy:"
            questionId="OtherGroupPolicy"
            options={["Yes", "No"]}
            columns={["Emp", "Sp"]}
          />
          <tr>
            <td />
            <td>
              a) Group Policy holder name
              <InputField name="OtherGroupPolicyName" {...data["OtherGroupPolicyName"]} />
              <br />
              b) Group Policy number
              <InputField name="OtherGroupPolicyNumber" {...data["OtherGroupPolicyNumber"]} />
              <br />
              c) Name of Spouse (who is Employee under that Policy)
              <InputField
                name="OtherGroupPolicySpouseName"
                {...data["OtherGroupPolicySpouseName"]}
              />
              <br />
              d) NRIC/PP no. of Spouse
              <InputField
                name="OtherGroupPolicySpouseIdentification"
                {...data["OtherGroupPolicySpouseIdentification"]}
              />
            </td>
            <td />
            <td />
            <td />
            <td />
          </tr>
          <tr>
            <td>11</td>
            <td>Female only *</td>
            <td />
            <td />
            <td />
            <td />
          </tr>
          <RadioButtonGroup
            data={data}
            field={data["EmpPapSmearResult"]}
            questionDesc="a) Have you ever been to any doctor for a Pap Smear (cervical smear)? If yes, please state result"
            questionId="PapSmear"
            options={["Yes", "No"]}
            columns={["Emp", "Sp"]}
          />
          <RadioButtonGroup
            data={data}
            questionDesc="b) Have you at any time in the past been advised by any doctor to have a repeated Pap Smear within 6 months?"
            questionId="PapSmearDisorder"
            options={["Yes", "No"]}
            columns={["Emp", "Sp"]}
          />
          <RadioButtonGroup
            data={data}
            questionDesc="c) Have you ever consulted a doctor for irregular, painful menstruation or other problem(s) involving the female organs, or breasts?"
            questionId="MenstruationDisorder"
            options={["Yes", "No"]}
            columns={["Emp", "Sp"]}
          />
          <RadioButtonGroup
            data={data}
            questionDesc="d) Have you been to a doctor for a &quot;breast check-up&quot;, or been advised to have an X-ray (mammogram), biopsy, or operation of the breast?"
            questionId="Gynaecological"
            options={["Yes", "No"]}
            columns={["Emp", "Sp"]}
          />
          <RadioButtonGroup
            data={data}
            questionDesc="e) Have any of your family members (namely grandmother, aunt(s), mother, sister(s) been diagnosed to have breast cancer?If yes, please complete the following :"
            questionId="BreastCancer"
            options={["Yes", "No"]}
            columns={["Emp", "Sp"]}
          />
          <tr>
            <td />
            <td className="subitem">
              <table className="border--default text--center" style={{ textIndent: 0 }}>
                <thead>
                  <tr>
                    <th width="30%" rowSpan={2}>
                      Relationship to Insured
                    </th>
                    <th width="25%" rowSpan={2}>
                      Age of Diagnosis
                    </th>
                    <th width="45%" colSpan={3}>
                      Breast involvement
                    </th>
                  </tr>
                  <tr>
                    <th>One</th>
                    <th>Both</th>
                    <th>Unknown</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <InputField
                        name="EmpBreastCancerFamilyRelation1"
                        {...data["EmpBreastCancerFamilyRelation1"]}
                      />
                    </td>
                    <td>
                      <InputField
                        name="EmpBreastCancerFamilyAgeDiagnosed1"
                        {...data["EmpBreastCancerFamilyAgeDiagnosed1"]}
                      />
                    </td>
                    <td>
                      <InputField
                        name="EmpBreastCancerFamilyOne1"
                        {...data["EmpBreastCancerFamilyOne1"]}
                      />
                    </td>
                    <td>
                      <InputField
                        name="EmpBreastCancerFamilyBoth1"
                        {...data["EmpBreastCancerFamilyBoth1"]}
                      />
                    </td>
                    <td>
                      <InputField
                        name="EmpBreastCancerFamilyUnknown1"
                        {...data["EmpBreastCancerFamilyUnknown1"]}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <InputField
                        name="EmpBreastCancerFamilyRelation2"
                        {...data["EmpBreastCancerFamilyRelation2"]}
                      />
                    </td>
                    <td>
                      <InputField
                        name="EmpBreastCancerFamilyAgeDiagnosed2"
                        {...data["EmpBreastCancerFamilyAgeDiagnosed2"]}
                      />
                    </td>
                    <td>
                      <InputField
                        name="EmpBreastCancerFamilyOne2"
                        {...data["EmpBreastCancerFamilyOne2"]}
                      />
                    </td>
                    <td>
                      <InputField
                        name="EmpBreastCancerFamilyBoth2"
                        {...data["EmpBreastCancerFamilyBoth2"]}
                      />
                    </td>
                    <td>
                      <InputField
                        name="EmpBreastCancerFamilyUnknown2"
                        {...data["EmpBreastCancerFamilyUnknown2"]}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <InputField
                        name="EmpBreastCancerFamilyRelation3"
                        {...data["EmpBreastCancerFamilyRelation3"]}
                      />
                    </td>
                    <td>
                      <InputField
                        name="EmpBreastCancerFamilyAgeDiagnosed3"
                        {...data["EmpBreastCancerFamilyAgeDiagnosed3"]}
                      />
                    </td>
                    <td>
                      <InputField
                        name="EmpBreastCancerFamilyOne3"
                        {...data["EmpBreastCancerFamilyOne3"]}
                      />
                    </td>
                    <td>
                      <InputField
                        name="EmpBreastCancerFamilyBoth3"
                        {...data["EmpBreastCancerFamilyBoth3"]}
                      />
                    </td>
                    <td>
                      <InputField
                        name="EmpBreastCancerFamilyUnknown3"
                        {...data["EmpBreastCancerFamilyUnknown3"]}
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
            <td />
            <td />
            <td />
            <td />
          </tr>
          <RadioButtonGroup
            data={data}
            field={data["EmpPregnantDurationValue"]}
            questionDesc="f) Are you currently pregnant? If so, how many months?"
            questionId="Pregnant"
            options={["Yes", "No"]}
            columns={["Emp", "Sp"]}
          />
          <RadioButtonGroup
            data={data}
            field={data["EmpHaveBeenPregnantAge"]}
            questionDesc="g) Have you ever been pregnant? At what age was your 1st pregnancy?"
            questionId="HaveBeenPregnant"
            options={["Yes", "No"]}
            columns={["Emp", "Sp"]}
          />
        </tbody>
      </table>
    </fieldset>
  );
};

MedicalQuestionnaire.propTypes = {
  data: PropTypes.object,
};

export default MedicalQuestionnaire;



// WEBPACK FOOTER //
// ./components/employee/hdf_forms/Aia/AIAHD201706_NOCHILD/MedicalQuestionnaire.js